export class Recuperacao {
    palavras: Array<string>;
    codigoChave: string;
    novoPin: string;
}
